<nb-card>
  <nb-card-header class="p-0">
    <span class="title">{{ title }}</span>
  </nb-card-header>
  <nb-card-body class="p-0">
    @if (content) {
      <p>
        <span [innerHTML]="content"></span>
      </p>
    }
    @if (contentBis) {
      <p>
        <span [innerHTML]="contentBis"></span>
      </p>
    }
  </nb-card-body>
  <nb-card-footer class="text-right">
    @if (canCancel) {
      <button nbButton status="warning" class="cancel-button" (click)="close()">
        {{ 'theme.status-change-dialog.discard' | translate }}
      </button>
    }
    <button nbButton (click)="close(true)">
      {{ 'theme.status-change-dialog.ok' | translate }}
    </button>
  </nb-card-footer>
</nb-card>
